export default __webpack_public_path__ + "static/media/Lincoln Heritage Dark.65307a36.svg";